import { useState } from "react";
import { Breadcrumb, Button, Card, Tabs } from "antd";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../assests/images/paymentbread.svg";
import AccountCard from "../../components/account-card";
import { ReactComponent as BeneTransferIcon } from "../../assests/images/beneTransfer.svg";
import { ReactComponent as AddIcon } from "../../assests/images/Add.svg";
import { ReactComponent as QuickIcon } from "../../assests/images/QuickTransfer.svg";
import { ReactComponent as HistoryIcon } from "../../assests/images/Download.svg";
import { profileDetailsSelector } from "../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import { ReactComponent as ScheduleTransIcon } from "../../assests/images/scheduledTransfer.svg";

export default function Payment() {
  const navigate = useNavigate();
  const profileDetails = useSelector(profileDetailsSelector);
  const { t } = useTranslation();
  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.payments", {
                defaultValue: "Payments",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.payments", {
                defaultValue: "Payments",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card"  >
            <AccountCard currencyFilter={true} />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card ">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/bill-payment/add-biller")}
                >
                  <div className="my-3">
                    <AddIcon height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.pay_bills.add_biller", {
                        defaultValue: "Add Biller",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t(
                        "pages.pay_bills.maintain_service_provider",
                        {
                          defaultValue:
                            "Maintain a service provider beneficiary",
                        }
                      )}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/bill-payment/view-biller")}
                >
                  <div className="my-3">
                    <QuickIcon height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.pay_bills.view_biller", {
                        defaultValue: "View Biller",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t(
                        "pages.pay_bills.view_maintained_provider",
                        {
                          defaultValue:
                            "View maintained all provider beneficiaries",
                        }
                      )}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/bill-payment")}
                >
                  <div className="my-3">
                    <BeneTransferIcon height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.pay_bills.pay_bills", {
                        defaultValue: "Pay Bills",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t("pages.pay_bills.make_bill_payments", {
                        defaultValue: "Make Bill payments",
                      })}{" "}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/bill-payment/history")}
                >
                  <div className="my-3">
                    <HistoryIcon height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("buttons.payment_history_btn", {
                        defaultValue: "Payment History",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t(
                        "pages.pay_bills.download_your_receipts",
                        {
                          defaultValue: "Download your Receipts",
                        }
                      )}{" "}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/scheduled-payments")}
                >
                  <div className="my-3">
                    <ScheduleTransIcon height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.pay_bills.view_scheduled_payments", {
                        defaultValue: "View Scheduled Payments",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t(
                        "pages.pay_bills.manage_scheduled_payments",
                        {
                          defaultValue: "Manage scheduled Payments",
                        }
                      )}{" "}
                    </span>
                  </div>
                </Card>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
